module.exports = __webpack_public_path__ + "static/PRESS-76c3822806548d69e18100ab7b43b24e.png";